
import { motion, useSpring } from 'framer-motion';
import { useState, useRef } from 'react';
import  {projectsData}  from './Projects';

function Project3() {
  const [img, setImg] = useState({
    src: '',
    alt: '',
    opacity: 0,
  });
  const imageRef = useRef(null);
  const containerRef = useRef(null);
  
  const spring = {
    stiffness: 150,
    damping: 15,
    mass: 0.1,
  };
  const imagePos = {
    x: useSpring(0, spring),
    y: useSpring(0, spring),
  };
  const handleMove = (e) => {
    if (!imageRef.current || !containerRef.current) return;
    const containerRect = containerRef.current.getBoundingClientRect();
    const { clientX, clientY } = e;
    const relativeX = clientX - containerRect.left;
    const relativeY = clientY - containerRect.top;
    imagePos.x.set(relativeX - imageRef.current.offsetWidth / 2);
    imagePos.y.set(relativeY - imageRef.current.offsetHeight / 2);
  };
  const handleImageInteraction = (item, opacity) => {
    setImg({ src: item.img, alt: item.label, opacity });
  };
  return (
    <div className='  mb-10 sm:p-6 p-4 sm:pt-6 pt-16'>
       <h1 className='text-[8vw] lg:text-5xl font-bold  text-[#FFDC00] relative'>projects
      <span className='absolute -bottom-4 left-0 w-full h-0.5 bg-gradient-to-r from-[#FFDC00] to-transparent '></span>
      </h1>
    <section
      ref={containerRef}
      onMouseMove={handleMove}
      className=" relative w-full mt-10 ">
      {projectsData.map((item) => (
        <div
          key={item.label}
          onMouseEnter={() => handleImageInteraction(item, 1)}
          onMouseMove={() => handleImageInteraction(item, 1)}
          onMouseLeave={() => handleImageInteraction(item, 0)}
          className="group w-full py-5 cursor-pointer text-center flex justify-between text-white  border-b border-zinc-500 last:border-none">
          <p className="sm:text-5xl text-nowrap text-[5vw] group-hover:text-white sm:group-hover:translate-x-20 text-gray-400 transition-all duration-500"><a href={item.link} target='_blank'>{item.name}</a></p>
          <i className="hidden  sm:group-hover:inline-block text-4xl text-[#FFDC00] ri-eye-line"></i>
        </div>
      ))}

      <motion.img
        ref={imageRef}
        src={img.src}
        alt={img.alt}
        className="sm:w-[350px] w-[220px]  sm:h-[220px] h-[150px] rounded-lg object-cover absolute top-0 left-0 transition-opacity duration-200 ease-in-out pointer-events-none"
        style={{
          x: imagePos.x,
          y: imagePos.y,
          opacity: img.opacity,
        }}
      />
    </section>
    </div>
  );
}
export default Project3;
